module.exports = __webpack_public_path__ + "60b9575cc36342baf7a574f68ded7129.png";